import isEqual from 'lodash/isEqual';
import { useState, useCallback, useEffect } from 'react';
// @mui
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Container from '@mui/material/Container';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import TableContainer from '@mui/material/TableContainer';
// routes
import { paths } from 'src/routes/paths';
import { useParams, useRouter } from 'src/routes/hooks';
// _mock
import { _userList } from 'src/_mock';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import {
    useTable,
    getComparator,
    emptyRows,
    TableNoData,
    TableEmptyRows,
    TableHeadCustom,
    TableSelectedAction,
    TablePaginationCustom,
} from 'src/components/table';

//
import UserTableRow from './stt-folders-table-list-show';
import { SttFodlesCreateModalShow } from './stt-create-show-modal';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
// ----------------------------------------------------------------------


const TABLE_HEAD = [
    { id: 'name', label: 'Name' },
    { id: 'name', label: 'Actions' },
];

const defaultFilters = {
    name: '',
    role: [],
    status: 'all',
};
// ----------------------------------------------------------------------

export default function SttFolderListShow() {
    const table = useTable();

    const settings = useSettingsContext();
    const { id } = useParams()
    const router = useRouter();

    const confirm = useBoolean();
    const add = useBoolean();

    const [ tableData, setTableData ] = useState(_userList);

    const [ filters, setFilters ] = useState(defaultFilters);

    const dataFiltered = applyFilter({
        inputData: tableData,
        comparator: getComparator(table.order, table.orderBy),
        filters,
    });

    const dataInPage = dataFiltered.slice(
        table.page * table.rowsPerPage,
        table.page * table.rowsPerPage + table.rowsPerPage
    );

    const denseHeight = table.dense ? 52 : 72;

    const canReset = !isEqual(defaultFilters, filters);

    const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

    const handleFilters = useCallback(
        (name, value) => {
            table.onResetPage();
            setFilters((prevState) => ({
                ...prevState,
                [ name ]: value,
            }));
        },
        [ table ]
    );


    useEffect(() => {
        getSttFoldersDetails();
    }, []);

    const getSttFoldersDetails = async (page = 1) => {
        const data = await getRequest(`${endpoints.admin_dashboard.teachnical_database.stt_folders.show_list}/${id}/stt-topics`);
        if (data) {
            console.log("🚀 ~ getSttFoldersDetails ~ data:", data)
            setTableData(data || []);
        }
    };



    const handleDeleteRow = useCallback(
        (id) => {
            const deleteRow = tableData.filter((row) => row.id !== id);
            setTableData(deleteRow);

            table.onUpdatePageDeleteRow(dataInPage.length);
        },
        [ dataInPage.length, table, tableData ]
    );

    const handleDeleteRows = useCallback(() => {
        const deleteRows = tableData.filter((row) => !table.selected.includes(row.id));
        setTableData(deleteRows);

        table.onUpdatePageDeleteRows({
            totalRows: tableData.length,
            totalRowsInPage: dataInPage.length,
            totalRowsFiltered: dataFiltered.length,
        });
    }, [ dataFiltered.length, dataInPage.length, table, tableData ]);

    const handleEditRow = useCallback(
        (id) => {
            router.push(paths.dashboard.user.edit(id));
        },
        [ router ]
    );

    const handleFilterStatus = useCallback(
        (event, newValue) => {
            handleFilters('status', newValue);
        },
        [ handleFilters ]
    );

    const handleResetFilters = useCallback(() => {
        setFilters(defaultFilters);
    }, []);

    return (
        <>
            <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
                <CustomBreadcrumbs
                    heading="Saftey Toolbox talk  Categories List"
                    links={ [
                        { name: '', href: paths.dashboard.root },

                    ] }
                    action={
                        <Button
                            onClick={ () => add.onTrue() }
                            // component={ RouterLink }
                            // href={ paths.dashboard.product_user_offers_create }
                            variant="contained"
                            startIcon={ <Iconify icon="mingcute:add-line" /> }
                        >
                            Saftey Toolbox Talk Topic List
                        </Button>
                    }
                    sx={ {
                        mb: { xs: 3, md: 5 },
                    } }
                />

                <Card>


                    <TableContainer sx={ { position: 'relative', overflow: 'unset' } }>
                        <TableSelectedAction
                            dense={ table.dense }
                            numSelected={ table.selected.length }
                            rowCount={ tableData.length }
                            onSelectAllRows={ (checked) =>
                                table.onSelectAllRows(
                                    checked,
                                    tableData.map((row) => row.id)
                                )
                            }
                            action={
                                <Tooltip title="Delete">
                                    <IconButton color="primary" onClick={ confirm.onTrue }>
                                        <Iconify icon="solar:trash-bin-trash-bold" />
                                    </IconButton>
                                </Tooltip>
                            }
                        />

                        <Scrollbar>
                            <Table size={ table.dense ? 'small' : 'medium' } sx={ { minWidth: 960 } }>
                                <TableHeadCustom
                                    order={ table.order }
                                    orderBy={ table.orderBy }
                                    headLabel={ TABLE_HEAD }
                                    rowCount={ tableData.length }
                                    numSelected={ table.selected.length }
                                    onSort={ table.onSort }
                                    onSelectAllRows={ (checked) =>
                                        table.onSelectAllRows(
                                            checked,
                                            tableData.map((row) => row.id)
                                        )
                                    }
                                />

                                <TableBody>
                                    { dataFiltered
                                        .slice(
                                            table.page * table.rowsPerPage,
                                            table.page * table.rowsPerPage + table.rowsPerPage
                                        )
                                        .map((row) => (
                                            <UserTableRow
                                                key={ row.id }
                                                row={ row }
                                                selected={ table.selected.includes(row.id) }
                                                onSelectRow={ () => table.onSelectRow(row.id) }
                                                onDeleteRow={ () => handleDeleteRow(row.id) }
                                                onEditRow={ () => handleEditRow(row.id) }
                                            />
                                        )) }

                                    <TableEmptyRows
                                        height={ denseHeight }
                                        emptyRows={ emptyRows(table.page, table.rowsPerPage, tableData.length) }
                                    />

                                    <TableNoData notFound={ notFound } />
                                </TableBody>
                            </Table>
                        </Scrollbar>
                    </TableContainer>

                    <TablePaginationCustom
                        count={ dataFiltered.length }
                        page={ table.page }
                        rowsPerPage={ table.rowsPerPage }
                        onPageChange={ table.onChangePage }
                        onRowsPerPageChange={ table.onChangeRowsPerPage }
                        //
                        dense={ table.dense }
                        onChangeDense={ table.onChangeDense }
                    />
                </Card>
            </Container>
            <SttFodlesCreateModalShow
                open={ add.value } onClose={ add.onFalse }
                reload={ () => getSttFoldersDetails() }
            />

            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content={
                    <>
                        Are you sure want to delete <strong> { table.selected.length } </strong> items?
                    </>
                }
                action={
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ () => {
                            handleDeleteRows();
                            confirm.onFalse();
                        } }
                    >
                        Delete
                    </Button>
                }
            />
        </>
    );
}

// ----------------------------------------------------------------------

function applyFilter({ inputData, comparator, filters }) {
    const { name, status, role } = filters;

    const stabilizedThis = inputData.map((el, index) => [ el, index ]);

    stabilizedThis.sort((a, b) => {
        const order = comparator(a[ 0 ], b[ 0 ]);
        if (order !== 0) return order;
        return a[ 1 ] - b[ 1 ];
    });

    inputData = stabilizedThis.map((el) => el[ 0 ]);

    if (name) {
        inputData = inputData.filter(
            (user) => user.name.toLowerCase().indexOf(name.toLowerCase()) !== -1
        );
    }

    if (status !== 'all') {
        inputData = inputData.filter((user) => user.status === status);
    }

    if (role.length) {
        inputData = inputData.filter((user) => role.includes(user.role));
    }

    return inputData;
}
